export default {
    EVENTTITLES ({ eventTitles }) {
      return eventTitles
    },
    EVENTPOOL_THEMES ({ eventPoolThemes }) {
      return eventPoolThemes
    },
    INTERESTS_STATUS ({ interestsStatus }) {
      return interestsStatus
    }
  }
